import React from "react";
import { getTextColor } from "../utils/getColors";

export default function DemoNoticeModal({ visible, onClose, webTemplate }) {
	if (!visible) return null;

	const primaryColor = webTemplate?.mainColor || "#2563eb";
	const bgColor = webTemplate?.backgroundColor || "#ffffff";
	const textColor = getTextColor(bgColor);

	return (
		<div className="fixed inset-0 z-[999] flex items-center justify-center px-4">
			<div className="absolute inset-0 bg-black/40 backdrop-blur-sm"></div>

			<div
				className="relative w-full max-w-md rounded-2xl shadow-2xl border px-6 py-6 space-y-4 transition-all duration-300"
				style={{
					backgroundColor: bgColor,
					color: textColor,
					borderColor: `${primaryColor}30`,
				}}
			>
				<div className="flex items-start gap-3">
					<div
						className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0"
						style={{ backgroundColor: `${primaryColor}15`, color: primaryColor }}
					>
						⚠️
					</div>
					<div className="space-y-2">
						<h3 className="text-lg font-semibold">
							Contenido de demostración
						</h3>
						<p className="text-sm leading-relaxed opacity-80">
							Esta vista previa muestra textos e imágenes de ejemplo para que veas
							cómo se vería tu web. Personaliza cada sección desde el panel de
							Applaby Creator para reemplazarlo por tu contenido real.
						</p>
					</div>
				</div>

				<button
					onClick={onClose}
					className="w-full py-2.5 rounded-xl font-semibold transition-transform hover:scale-[1.01]"
					style={{
						backgroundColor: primaryColor,
						color: getTextColor(primaryColor),
					}}
				>
					Entendido
				</button>
			</div>
		</div>
	);
}

